export const environment = {
  production: false,
  bffApi: 'https://homolog.teadit.app:44340/api',
  Acessos: {
    cotacao: [
      {
        IdStatus: '999', //sem acesso
        Perfil: '',
        cliente: true,
        clienteInfo: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha:true,
        declararPerdida:true,
        declararCancelada:true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '0', //nova
        Perfil: 'Engenharia',
        cliente: true,
        clienteInfo: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '1', //pendente
        Perfil: 'Engenharia',
        cliente: true,
        clienteInfo: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '2', //cancelada
        Perfil: 'Engenharia',
        cliente: true,
        clienteInfo: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '3', //expirada
        Perfil: 'Engenharia',
        cliente: true,
        clienteInfo: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '4', //Ganha
        Perfil: 'Engenharia',
        cliente: true,
        clienteInfo: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '5', //ganhaparcial
        Perfil: 'Engenharia',
        cliente: true,
        clienteInfo: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '6', //perdida
        Perfil: 'Engenharia',
        cliente: true,
        clienteInfo: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '7', //rascunho
        Perfil: 'Engenharia',
        cliente: true,
        clienteInfo: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '8', //excluida
        Perfil: 'Engenharia',
        cliente: true,
        clienteInfo: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '9', //cpe
        Perfil: 'Engenharia',
        cliente: true,
        clienteInfo: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '0', //nova
        Perfil: 'VendasInternas',
        cliente: false,
        clienteInfo: false,
        empresa: false,
        dataDoRecebimento: false,
        dataDoVencimento: false,
        tipoDeUtilizacao: false,
        numeroDaCotacaoDoCliente: false,
        validadeEmDias: false,
        motivoDaCotacao: false,
        origemDaCotacao: false,
        emergencial: false,
        valorAcrescimoEmergencia: false,
        tempoDeProducao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        observacao: false,
        editar: false,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: false,
        detalheDoItem: false,
        duplicar: true
      },
      {
        IdStatus: '1', //pendente
        Perfil: 'VendasInternas',
        cliente: false,
        clienteInfo: false,
        empresa: false,
        dataDoRecebimento: false,
        dataDoVencimento: false,
        tipoDeUtilizacao: false,
        numeroDaCotacaoDoCliente: false,
        validadeEmDias: false,
        motivoDaCotacao: false,
        origemDaCotacao: false,
        emergencial: false,
        valorAcrescimoEmergencia: false,
        tempoDeProducao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        observacao: false,
        editar: false,
        declarar: false,
        declararGanha: false,
        declararPerdida: false,
        declararCancelada: false,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '2', //cancelada
        Perfil: 'VendasInternas',
        cliente: true,
        clienteInfo: false,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '3', //expirada
        Perfil: 'VendasInternas',
        cliente: true,
        clienteInfo: false,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '4', //Ganha
        Perfil: 'VendasInternas',
        cliente: true,
        clienteInfo: false,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '5', //ganhaparcial
        Perfil: 'VendasInternas',
        cliente: true,
        clienteInfo: false,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '6', //perdida
        Perfil: 'VendasInternas',
        cliente: true,
        clienteInfo: false,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '7', //rascunho
        Perfil: 'VendasInternas',
        cliente: false,
        clienteInfo: false,
        empresa: false,
        dataDoRecebimento: false,
        dataDoVencimento: false,
        tipoDeUtilizacao: false,
        numeroDaCotacaoDoCliente: false,
        validadeEmDias: false,
        motivoDaCotacao: false,
        origemDaCotacao: false,
        emergencial: false,
        valorAcrescimoEmergencia: false,
        tempoDeProducao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        observacao: false,
        editar: false,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '8', //excluida
        Perfil: 'VendasInternas',
        cliente: true,
        clienteInfo: false,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '9', //cpe
        Perfil: 'VendasInternas',
        cliente: false,
        clienteInfo: false,
        empresa: false,
        dataDoRecebimento: false,
        dataDoVencimento: false,
        tipoDeUtilizacao: false,
        numeroDaCotacaoDoCliente: false,
        validadeEmDias: false,
        motivoDaCotacao: false,
        origemDaCotacao: false,
        emergencial: false,
        valorAcrescimoEmergencia: false,
        tempoDeProducao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        observacao: false,
        editar: false,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '0', //nova
        Perfil: 'Fiscal',
        clienteInfo: false,
        cliente: false,
        empresa: false,
        dataDoRecebimento: false,
        dataDoVencimento: false,
        tipoDeUtilizacao: false,
        numeroDaCotacaoDoCliente: false,
        validadeEmDias: false,
        motivoDaCotacao: false,
        origemDaCotacao: false,
        emergencial: false,
        valorAcrescimoEmergencia: false,
        tempoDeProducao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        observacao: false,
        editar: false,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: false,
        detalheDoItem: false,
        duplicar: true
      },
      {
        IdStatus: '1', //pendente
        Perfil: 'Fiscal',
        clienteInfo: false,
        cliente: false,
        empresa: false,
        dataDoRecebimento: false,
        dataDoVencimento: false,
        tipoDeUtilizacao: false,
        numeroDaCotacaoDoCliente: false,
        validadeEmDias: false,
        motivoDaCotacao: false,
        origemDaCotacao: false,
        emergencial: false,
        valorAcrescimoEmergencia: false,
        tempoDeProducao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        observacao: false,
        editar: false,
        declarar: false,
        declararGanha: false,
        declararPerdida: false,
        declararCancelada: false,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '2', //cancelada
        Perfil: 'Fiscal',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '3', //expirada
        Perfil: 'Fiscal',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '4', //Ganha
        Perfil: 'Fiscal',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '5', //ganhaparcial
        Perfil: 'Fiscal',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '6', //perdida
        Perfil: 'Fiscal',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '7', //rascunho
        Perfil: 'Fiscal',
        clienteInfo: false,
        cliente: false,
        empresa: false,
        dataDoRecebimento: false,
        dataDoVencimento: false,
        tipoDeUtilizacao: false,
        numeroDaCotacaoDoCliente: false,
        validadeEmDias: false,
        motivoDaCotacao: false,
        origemDaCotacao: false,
        emergencial: false,
        valorAcrescimoEmergencia: false,
        tempoDeProducao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        observacao: false,
        editar: false,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '8', //excluida
        Perfil: 'Fiscal',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '9', //cpe
        Perfil: 'Fiscal',
        clienteInfo: false,
        cliente: false,
        empresa: false,
        dataDoRecebimento: false,
        dataDoVencimento: false,
        tipoDeUtilizacao: false,
        numeroDaCotacaoDoCliente: false,
        validadeEmDias: false,
        motivoDaCotacao: false,
        origemDaCotacao: false,
        emergencial: false,
        valorAcrescimoEmergencia: false,
        tempoDeProducao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        observacao: false,
        editar: false,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '0', //nova
        Perfil: 'Financeiro',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '1', //pendente
        Perfil: 'Financeiro',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '2', //cancelada
        Perfil: 'Financeiro',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '3', //expirada
        Perfil: 'Financeiro',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '4', //Ganha
        Perfil: 'Financeiro',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: false,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '5', //ganhaparcial
        Perfil: 'Financeiro',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: false,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '6', //perdida
        Perfil: 'Financeiro',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '7', //rascunho
        Perfil: 'Financeiro',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: false,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '8', //excluida
        Perfil: 'Financeiro',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '9', //cpe
        Perfil: 'Financeiro',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '0', //nova
        Perfil: 'Qualidade',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '1', //pendente
        Perfil: 'Qualidade',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '2', //cancelada
        Perfil: 'Qualidade',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '3', //expirada
        Perfil: 'Qualidade',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '4', //Ganha
        Perfil: 'Qualidade',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '5', //ganhaparcial
        Perfil: 'Qualidade',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '6', //perdida
        Perfil: 'Qualidade',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '7', //rascunho
        Perfil: 'Qualidade',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '8', //excluida
        Perfil: 'Qualidade',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '9', //cpe
        Perfil: 'Qualidade',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '0', //nova
        Perfil: 'Filial',
        clienteInfo: false,
        cliente: false,
        empresa: false,
        dataDoRecebimento: false,
        dataDoVencimento: false,
        tipoDeUtilizacao: false,
        numeroDaCotacaoDoCliente: false,
        validadeEmDias: false,
        motivoDaCotacao: false,
        origemDaCotacao: false,
        emergencial: false,
        valorAcrescimoEmergencia: false,
        tempoDeProducao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        observacao: false,
        editar: false,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: false,
        detalheDoItem: false,
        duplicar: true
      },
      {
        IdStatus: '1', //pendente
        Perfil: 'Filial',
        clienteInfo: false,
        cliente: false,
        empresa: false,
        dataDoRecebimento: false,
        dataDoVencimento: false,
        tipoDeUtilizacao: false,
        numeroDaCotacaoDoCliente: false,
        validadeEmDias: false,
        motivoDaCotacao: false,
        origemDaCotacao: false,
        emergencial: false,
        valorAcrescimoEmergencia: false,
        tempoDeProducao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        observacao: false,
        editar: false,
        declarar: false,
        declararGanha: false,
        declararPerdida: false,
        declararCancelada: false,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '2', //cancelada
        Perfil: 'Filial',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '3', //expirada
        Perfil: 'Filial',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '4', //Ganha
        Perfil: 'Filial',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '5', //ganhaparcial
        Perfil: 'Filial',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '6', //perdida
        Perfil: 'Filial',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '7', //rascunho
        Perfil: 'Filial',
        clienteInfo: false,
        cliente: false,
        empresa: false,
        dataDoRecebimento: false,
        dataDoVencimento: false,
        tipoDeUtilizacao: false,
        numeroDaCotacaoDoCliente: false,
        validadeEmDias: false,
        motivoDaCotacao: false,
        origemDaCotacao: false,
        emergencial: false,
        valorAcrescimoEmergencia: false,
        tempoDeProducao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        observacao: false,
        editar: false,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '8', //excluida
        Perfil: 'Filial',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '9', //cpe
        Perfil: 'Filial',
        clienteInfo: false,
        cliente: false,
        empresa: false,
        dataDoRecebimento: false,
        dataDoVencimento: false,
        tipoDeUtilizacao: false,
        numeroDaCotacaoDoCliente: false,
        validadeEmDias: false,
        motivoDaCotacao: false,
        origemDaCotacao: false,
        emergencial: false,
        valorAcrescimoEmergencia: false,
        tempoDeProducao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        observacao: false,
        editar: false,
        declarar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '0', //nova
        Perfil: 'VendasExterna',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '1', //pendente
        Perfil: 'VendasExterna',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: false,
        declararGanha: true,
        declararPerdida: false,
        declararCancelada: false,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '2', //cancelada
        Perfil: 'VendasExterna',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '3', //expirada
        Perfil: 'VendasExterna',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '4', //Ganha
        Perfil: 'VendasExterna',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '5', //ganhaparcial
        Perfil: 'VendasExterna',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '6', //perdida
        Perfil: 'VendasExterna',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '7', //rascunho
        Perfil: 'VendasExterna',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '8', //excluida
        Perfil: 'VendasExterna',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '9', //cpe
        Perfil: 'VendasExterna',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        dataDoRecebimento: true,
        dataDoVencimento: true,
        tipoDeUtilizacao: true,
        numeroDaCotacaoDoCliente: true,
        validadeEmDias: true,
        motivoDaCotacao: true,
        origemDaCotacao: true,
        emergencial: true,
        valorAcrescimoEmergencia: true,
        tempoDeProducao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacao: true,
        editar: true,
        declararGanha: true,
        declararPerdida: true,
        declararCancelada: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
    ],
    pedido: [
      {
        IdStatus: '999', //sem acesso
        Perfil: '',
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '0', //Rascunho
        Perfil: 'TI',
        cliente: false,
        clienteInfo: false,
        RazaoSocial: false,
        empresa: false,
        tipoDeRemessa: false,
        dataDoRecebimento: false,
        tipoDeUtilizacao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        updateItem: false,
        integracao: false,
        observacaoPedido: false,
        observacaoNota: false,
        aprovar: false,
        salvar: false,
        editar: false,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: false,
      },
      {
        IdStatus: '1', //aprovado
        Perfil: 'TI',
        cliente: false,
        clienteInfo: false,
        RazaoSocial: false,
        empresa: false,
        tipoDeRemessa: false,
        dataDoRecebimento: false,
        tipoDeUtilizacao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        updateItem: false,
        integracao: false,
        observacaoPedido: false,
        observacaoNota: false,
        aprovar: false,
        salvar: false,
        editar: false,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: false,
      },
      {
        IdStatus: '0', //Rascunho
        Perfil: 'Engenharia',
        cliente: true,
        clienteInfo: true,
        RazaoSocial: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        integracao: true,
        updateItem: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '1', //Aprovado
        Perfil: 'Engenharia',
        cliente: true,
        clienteInfo: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        integracao: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarIsencoes: true,
        editarValorTotalDoubleCheck: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '2', //Bloqueado
        Perfil: 'Engenharia',
        cliente: true,
        clienteInfo: true,
        RazaoSocial: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        integracao: true,
        updateItem: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '3', //Excluído
        Perfil: 'Engenharia',
        cliente: true,
        clienteInfo: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        integracao: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '4', //Rascunho
        Perfil: 'Engenharia',
        cliente: true,
        clienteInfo: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        integracao: true,
        updateItem: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '5', //Devolvido
        Perfil: 'Engenharia',
        cliente: true,
        clienteInfo: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        integracao: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '6', //Cancelado
        Perfil: 'Engenharia',
        cliente: true,
        clienteInfo: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        integracao: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '7', //Aprovado Parcialmente
        Perfil: 'Engenharia',
        cliente: true,
        clienteInfo: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        integracao: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '0', //Rascunho
        Perfil: 'VendasInternas',
        cliente: false,
        clienteInfo: false,
        RazaoSocial: false,
        empresa: false,
        tipoDeRemessa: false,
        dataDoRecebimento: false,
        tipoDeUtilizacao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        updateItem: false,
        observacaoPedido: false,
        integracao: true,
        observacaoNota: false,
        aprovar: false,
        salvar: false,
        editar: false,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: true
      },
      {
        IdStatus: '1', //Aprovado
        Perfil: 'VendasInternas',
        cliente: true,
        clienteInfo: false,
        empresa: true,
        tipoDeRemessa: false,
        dataDoRecebimento: true,
        tipoDeUtilizacao: false,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        updateItem: true,
        observacaoPedido: false,
        integracao: true,
        observacaoNota: false,
        aprovar: true,
        salvar: false,
        editar: false,
        editarIsencoes: false,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '2', //Bloqueado
        Perfil: 'VendasInternas',
        cliente: false,
        clienteInfo: false,
        RazaoSocial: false,
        empresa: false,
        tipoDeRemessa: false,
        dataDoRecebimento: false,
        tipoDeUtilizacao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        updateItem: false,
        observacaoPedido: false,
        integracao: true,
        observacaoNota: false,
        aprovar: true,
        salvar: false,
        editar: false,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: true
      },
      {
        IdStatus: '3', //Excluído
        Perfil: 'VendasInternas',
        cliente: true,
        clienteInfo: false,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        observacaoPedido: true,
        integracao: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '4', //Rascunho
        Perfil: 'VendasInternas',
        cliente: false,
        clienteInfo: false,
        empresa: false,
        tipoDeRemessa: false,
        dataDoRecebimento: false,
        tipoDeUtilizacao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        updateItem: false,
        observacaoPedido: false,
        integracao: true,
        observacaoNota: false,
        aprovar: false,
        salvar: false,
        editar: false,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '5', //Devolvido
        Perfil: 'VendasInternas',
        cliente: true,
        clienteInfo: false,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        observacaoPedido: true,
        integracao: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '6', //Cancelado
        Perfil: 'VendasInternas',
        cliente: true,
        clienteInfo: false,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        observacaoPedido: true,
        integracao: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '7', //Aprovado Parcialmente
        Perfil: 'VendasInternas',
        cliente: true,
        clienteInfo: false,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: false,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: false,
        updateItem: true,
        observacaoPedido: true,
        integracao: true,
        observacaoNota: true,
        aprovar: false,
        salvar: false,
        editar: true,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '0', //Rascunho
        Perfil: 'Fiscal',
        clienteInfo: false,
        cliente: false,
        RazaoSocial: false,
        empresa: false,
        tipoDeRemessa: false,
        dataDoRecebimento: false,
        tipoDeUtilizacao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        observacaoPedido: false,
        integracao: true,
        observacaoNota: false,
        aprovar: false,
        salvar: false,
        editar: false,
        criar: false,
        detalheDoItem: false,
        duplicar: true
      },
      {
        IdStatus: '1', //Aprovado
        Perfil: 'Fiscal',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacaoPedido: true,
        integracao: true,
        observacaoNota: true,
        aprovar: true,
        salvar: false,
        editar: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '2', //Bloqueado
        Perfil: 'Fiscal',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacaoPedido: true,
        integracao: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '3', //Excluído
        Perfil: 'Fiscal',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacaoPedido: true,
        integracao: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '4', //Rascunho
        Perfil: 'Fiscal',
        clienteInfo: false,
        cliente: false,
        empresa: false,
        tipoDeRemessa: false,
        dataDoRecebimento: false,
        tipoDeUtilizacao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        observacaoPedido: false,
        integracao: true,
        observacaoNota: false,
        aprovar: false,
        salvar: false,
        editar: false,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '5', //Devolvido
        Perfil: 'Fiscal',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacaoPedido: true,
        integracao: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '6', //Cancelado
        Perfil: 'Fiscal',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacaoPedido: true,
        integracao: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '0', //Rascunho
        Perfil: 'Financeiro',
        clienteInfo: false,
        cliente: false,
        RazaoSocial: false,
        empresa: false,
        tipoDeRemessa: false,
        dataDoRecebimento: false,
        tipoDeUtilizacao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        observacaoPedido: false,
        integracao: true,
        observacaoNota: false,
        aprovar: true,
        salvar: false,
        editar: false,
        criar: false,
        detalheDoItem: false,
        duplicar: true
      },
      {
        IdStatus: '1', //Aprovado
        Perfil: 'Financeiro',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacaoPedido: true,
        integracao: true,
        observacaoNota: true,
        aprovar: true,
        salvar: false,
        editar: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '2', //Bloqueado
        Perfil: 'Financeiro',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacaoPedido: true,
        integracao: true,
        observacaoNota: true,
        aprovar: true,
        salvar: false,
        editar: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '3', //Excluído
        Perfil: 'Financeiro',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacaoPedido: true,
        integracao: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '4', //Rascunho
        Perfil: 'Financeiro',
        clienteInfo: false,
        cliente: false,
        empresa: false,
        tipoDeRemessa: false,
        dataDoRecebimento: false,
        tipoDeUtilizacao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        observacaoPedido: false,
        integracao: true,
        observacaoNota: false,
        aprovar: true,
        salvar: false,
        editar: false,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '5', //Devolvido
        Perfil: 'Financeiro',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacaoPedido: true,
        integracao: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '6', //Cancelado
        Perfil: 'Financeiro',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        observacaoPedido: true,
        integracao: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '7', //Aprovado Parcialmente
        Perfil: 'Financeiro',
        clienteInfo: false,
        cliente: false,
        RazaoSocial: false,
        empresa: false,
        tipoDeRemessa: false,
        dataDoRecebimento: false,
        tipoDeUtilizacao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        observacaoPedido: false,
        integracao: true,
        observacaoNota: false,
        aprovar: true,
        salvar: false,
        editar: false,
        criar: false,
        detalheDoItem: false,
        duplicar: true
      },
      {
        IdStatus: '0', //Rascunho
        Perfil: 'PCP',
        clienteInfo: true,
        cliente: false,
        RazaoSocial: false,
        empresa: false,
        tipoDeRemessa: false,
        dataDoRecebimento: false,
        tipoDeUtilizacao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        updateItem: false,
        observacaoPedido: false,
        integracao: true,
        observacaoNota: false,
        aprovar: false,
        salvar: false,
        editar: false,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: true
      },
      {
        IdStatus: '1', //Aprovado
        Perfil: 'PCP',
        clienteInfo: true,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: false,
        moeda: true,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        updateItem: true,
        observacaoPedido: false,
        integracao: true,
        observacaoNota: false,
        aprovar: true,
        salvar: false,
        editar: false,
        editarIsencoes: true,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '2', //Bloqueado
        Perfil: 'PCP',
        clienteInfo: true,
        cliente: false,
        RazaoSocial: false,
        empresa: false,
        tipoDeRemessa: false,
        dataDoRecebimento: false,
        tipoDeUtilizacao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        updateItem: false,
        observacaoPedido: false,
        integracao: true,
        observacaoNota: false,
        aprovar: true,
        salvar: false,
        editar: false,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: true
      },
      {
        IdStatus: '3', //Excluído
        Perfil: 'PCP',
        clienteInfo: true,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        observacaoPedido: true,
        integracao: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '4', //Rascunho
        Perfil: 'PCP',
        clienteInfo: true,
        cliente: false,
        empresa: false,
        tipoDeRemessa: false,
        dataDoRecebimento: false,
        tipoDeUtilizacao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        updateItem: false,
        observacaoPedido: false,
        integracao: true,
        observacaoNota: false,
        aprovar: false,
        salvar: false,
        editar: false,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '5', //Devolvido
        Perfil: 'PCP',
        clienteInfo: true,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        observacaoPedido: true,
        integracao: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '6', //Cancelado
        Perfil: 'PCP',
        clienteInfo: true,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        observacaoPedido: true,
        integracao: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '7', //Aprovado Parcialmente
        Perfil: 'PCP',
        clienteInfo: true,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: false,
        updateItem: true,
        observacaoPedido: true,
        integracao: true,
        observacaoNota: true,
        aprovar: false,
        salvar: false,
        editar: true,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '0', //Rascunho
        Perfil: 'Faturista',
        clienteInfo: false,
        cliente: false,
        RazaoSocial: false,
        empresa: false,
        tipoDeRemessa: false,
        dataDoRecebimento: false,
        tipoDeUtilizacao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        updateItem: false,
        observacaoPedido: false,
        integracao: true,
        observacaoNota: false,
        aprovar: false,
        salvar: false,
        editar: false,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: true
      },
      {
        IdStatus: '1', //Aprovado
        Perfil: 'Faturista',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: false,
        moeda: true,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        updateItem: true,
        observacaoPedido: false,
        integracao: true,
        observacaoNota: false,
        aprovar: true,
        salvar: false,
        editar: false,
        editarIsencoes: true,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '2', //Bloqueado
        Perfil: 'Faturista',
        clienteInfo: false,
        cliente: false,
        RazaoSocial: false,
        empresa: false,
        tipoDeRemessa: false,
        dataDoRecebimento: false,
        tipoDeUtilizacao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        updateItem: false,
        observacaoPedido: false,
        integracao: true,
        observacaoNota: false,
        aprovar: true,
        salvar: false,
        editar: false,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: true
      },
      {
        IdStatus: '3', //Excluído
        Perfil: 'Faturista',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        observacaoPedido: true,
        integracao: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '4', //Rascunho
        Perfil: 'Faturista',
        clienteInfo: false,
        cliente: false,
        empresa: false,
        tipoDeRemessa: false,
        dataDoRecebimento: false,
        tipoDeUtilizacao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        updateItem: false,
        observacaoPedido: false,
        integracao: true,
        observacaoNota: false,
        aprovar: false,
        salvar: false,
        editar: false,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '5', //Devolvido
        Perfil: 'Faturista',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        observacaoPedido: true,
        integracao: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '6', //Cancelado
        Perfil: 'Faturista',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        observacaoPedido: true,
        integracao: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '7', //Aprovado Parcialmente
        Perfil: 'Faturista',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: false,
        updateItem: true,
        observacaoPedido: true,
        integracao: true,
        observacaoNota: true,
        aprovar: false,
        salvar: false,
        editar: true,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '0', //Rascunho
        Perfil: 'Qualidade',

        clienteInfo: false,
        cliente: true,
        RazaoSocial: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        observacaoPedido: true,
        integracao: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '1', //Aprovado
        Perfil: 'Qualidade',

        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        observacaoPedido: true,
        integracao: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarIsencoes: true,
        editarValorTotalDoubleCheck: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '2', //Bloqueado
        Perfil: 'Qualidade',

        clienteInfo: false,
        cliente: true,
        RazaoSocial: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        observacaoPedido: true,
        integracao: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '3', //Excluído
        Perfil: 'Qualidade',

        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        observacaoPedido: true,
        integracao: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '4', //Rascunho
        Perfil: 'Qualidade',

        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        observacaoPedido: true,
        integracao: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '5', //Devolvido
        Perfil: 'Qualidade',

        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        observacaoPedido: true,
        integracao: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '6', //Cancelado
        Perfil: 'Qualidade',

        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        observacaoPedido: true,
        integracao: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '7', //Aprovado Parcialmente
        Perfil: 'Qualidade',

        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        observacaoPedido: true,
        integracao: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '0', //Rascunho
        Perfil: 'Filial',
        clienteInfo: false,
        cliente: false,
        RazaoSocial: false,
        empresa: false,
        tipoDeRemessa: false,
        dataDoRecebimento: false,
        tipoDeUtilizacao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        updateItem: false,
        observacaoPedido: false,
        integracao: true,
        observacaoNota: false,
        aprovar: false,
        salvar: false,
        editar: false,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: true
      },
      {
        IdStatus: '1', //Aprovado
        Perfil: 'Filial',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: false,
        dataDoRecebimento: true,
        tipoDeUtilizacao: false,
        contato: true,
        removeContato: false,
        moeda: true,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        updateItem: true,
        observacaoPedido: false,
        integracao: true,
        observacaoNota: false,
        aprovar: true,
        salvar: false,
        editar: false,
        editarIsencoes: false,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '2', //Bloqueado
        Perfil: 'Filial',
        clienteInfo: false,
        cliente: false,
        RazaoSocial: false,
        empresa: false,
        tipoDeRemessa: false,
        dataDoRecebimento: false,
        tipoDeUtilizacao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        updateItem: false,
        observacaoPedido: false,
        integracao: true,
        observacaoNota: false,
        aprovar: true,
        salvar: false,
        editar: false,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: true
      },
      {
        IdStatus: '3', //Excluído
        Perfil: 'Filial',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        observacaoPedido: true,
        integracao: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '4', //Rascunho
        Perfil: 'Filial',
        clienteInfo: false,
        cliente: false,
        empresa: false,
        tipoDeRemessa: false,
        dataDoRecebimento: false,
        tipoDeUtilizacao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        updateItem: false,
        observacaoPedido: false,
        integracao: true,
        observacaoNota: false,
        aprovar: false,
        salvar: false,
        editar: false,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '5', //Devolvido
        Perfil: 'Filial',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        observacaoPedido: true,
        integracao: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '6', //Cancelado
        Perfil: 'Filial',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        observacaoPedido: true,
        integracao: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '7', //Aprovado Parcialmente
        Perfil: 'Filial',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: false,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: false,
        updateItem: true,
        observacaoPedido: true,
        integracao: true,
        observacaoNota: true,
        aprovar: false,
        salvar: false,
        editar: true,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
    ],
    ordemDeFabricacao: [
      {
        IdStatus: '999', //sem acesso
        Perfil: '',
        novaOF: true,
        gerarOF: true,
        encerrarOF: true,
        cancelarOF: true,
        imprimir: true,
        gerarExcel: true,
        etiquetaPeloLote: true,
        etiquetaDetalhe: true,
        reverter: true,
        transformar: true,
        rejeitar: true

      },
      {
        IdStatus: '2', //Em produção
        Perfil: 'PCP',
        clienteInfo: true,
        novaOF: false,
        gerarOF: false,
        encerrarOF: false,
        cancelarOF: false,
        imprimir: false,
        gerarExcel: false,
        etiquetaPeloLote: false,
        etiquetaDetalhe: false,
        reverter: false,
        transformar: false,
        rejeitar: false

      },
      {
        IdStatus: '3', //Finalizado
        Perfil: 'PCP',
        clienteInfo: true,
        novaOF: false,
        gerarOF: false,
        encerrarOF: false,
        cancelarOF: false,
        imprimir: false,
        gerarExcel: false,
        etiquetaPeloLote: false,
        etiquetaDetalhe: false,
        reverter: false,
        transformar: false,
        rejeitar: false

      },
      {
        IdStatus: '4', //Cancelado
        Perfil: 'PCP',
        clienteInfo: true,
        novaOF: false,
        gerarOF: false,
        encerrarOF: false,
        cancelarOF: false,
        imprimir: false,
        gerarExcel: false,
        etiquetaPeloLote: false,
        etiquetaDetalhe: false,
        reverter: false,
        transformar: false,
        rejeitar: false

      },
      {
        IdStatus: '6', //Transformado
        Perfil: 'PCP',
        clienteInfo: true,
        novaOF: false,
        gerarOF: false,
        encerrarOF: false,
        cancelarOF: false,
        imprimir: false,
        gerarExcel: false,
        etiquetaPeloLote: false,
        etiquetaDetalhe: false,
        reverter: false,
        transformar: false,
        rejeitar: false

      },
      {
        IdStatus: '7', //Rejeitado
        Perfil: 'PCP',
        clienteInfo: true,
        novaOF: false,
        gerarOF: false,
        encerrarOF: false,
        cancelarOF: false,
        imprimir: false,
        gerarExcel: false,
        etiquetaPeloLote: false,
        etiquetaDetalhe: false,
        reverter: false,
        transformar: false,
        rejeitar: false

      },
      {
        IdStatus: '2', //Em produção
        Perfil: 'Fabrica',
        novaOF: true,
        gerarOF: true,
        encerrarOF: false,
        cancelarOF: true,
        imprimir: false,
        gerarExcel: false,
        etiquetaPeloLote: false,
        etiquetaDetalhe: false,
        reverter: true,
        transformar: false,
        rejeitar: false

      },
      {
        IdStatus: '3', //Finalizado
        Perfil: 'Fabrica',
        novaOF: true,
        gerarOF: true,
        encerrarOF: true,
        cancelarOF: true,
        imprimir: false,
        gerarExcel: false,
        etiquetaPeloLote: false,
        etiquetaDetalhe: false,
        reverter: true,
        transformar: false,
        rejeitar: false

      },
      {
        IdStatus: '4', //Cancelado
        Perfil: 'Fabrica',
        novaOF: true,
        gerarOF: true,
        encerrarOF: true,
        cancelarOF: true,
        imprimir: false,
        gerarExcel: false,
        etiquetaPeloLote: false,
        etiquetaDetalhe: false,
        reverter: true,
        transformar: false,
        rejeitar: false

      },
      {
        IdStatus: '6', //Transformado
        Perfil: 'Fabrica',
        novaOF: true,
        gerarOF: true,
        encerrarOF: true,
        cancelarOF: true,
        imprimir: false,
        gerarExcel: false,
        etiquetaPeloLote: false,
        etiquetaDetalhe: false,
        reverter: true,
        transformar: false,
        rejeitar: false

      },
      {
        IdStatus: '7', //Rejeitado
        Perfil: 'Fabrica',
        novaOF: true,
        gerarOF: true,
        encerrarOF: true,
        cancelarOF: true,
        imprimir: false,
        gerarExcel: false,
        etiquetaPeloLote: false,
        etiquetaDetalhe: false,
        reverter: true,
        transformar: false,
        rejeitar: false

      },
      {
        IdStatus: '2', //Em produção
        Perfil: 'Qualidade',

        clienteInfo: false,
        novaOF: true,
        gerarOF: true,
        encerrarOF: true,
        cancelarOF: true,
        imprimir: true,
        gerarExcel: true,
        etiquetaPeloLote: true,
        etiquetaDetalhe: true,
        reverter: true,
        transformar: true,
        rejeitar: true

      },
      {
        IdStatus: '3', //Finalizado
        Perfil: 'Qualidade',

        clienteInfo: false,
        novaOF: true,
        gerarOF: true,
        encerrarOF: true,
        cancelarOF: true,
        imprimir: true,
        gerarExcel: true,
        etiquetaPeloLote: true,
        etiquetaDetalhe: true,
        reverter: true,
        transformar: true,
        rejeitar: true

      },
      {
        IdStatus: '4', //Cancelado
        Perfil: 'Qualidade',

        clienteInfo: false,
        novaOF: true,
        gerarOF: true,
        encerrarOF: true,
        cancelarOF: true,
        imprimir: true,
        gerarExcel: true,
        etiquetaPeloLote: true,
        etiquetaDetalhe: true,
        reverter: true,
        transformar: true,
        rejeitar: true

      },
      {
        IdStatus: '6', //Transformado
        Perfil: 'Qualidade',

        clienteInfo: false,
        novaOF: true,
        gerarOF: true,
        encerrarOF: true,
        cancelarOF: true,
        imprimir: true,
        gerarExcel: true,
        etiquetaPeloLote: true,
        etiquetaDetalhe: true,
        reverter: true,
        transformar: true,
        rejeitar: true

      },
      {
        IdStatus: '7', //Rejeitado
        Perfil: 'Qualidade',

        clienteInfo: false,
        novaOF: true,
        gerarOF: true,
        encerrarOF: true,
        cancelarOF: true,
        imprimir: true,
        gerarExcel: true,
        etiquetaPeloLote: true,
        etiquetaDetalhe: true,
        reverter: true,
        transformar: true,
        rejeitar: true

      },
      {
        IdStatus: '2', //Em produção
        Perfil: 'Filial',
        clienteInfo: false,
        novaOF: false,
        gerarOF: false,
        encerrarOF: false,
        cancelarOF: false,
        imprimir: false,
        gerarExcel: false,
        etiquetaPeloLote: false,
        etiquetaDetalhe: false,
        reverter: false,
        transformar: false,
        rejeitar: false

      },
      {
        IdStatus: '3', //Finalizado
        Perfil: 'Filial',
        clienteInfo: false,
        novaOF: false,
        gerarOF: false,
        encerrarOF: false,
        cancelarOF: false,
        imprimir: false,
        gerarExcel: false,
        etiquetaPeloLote: false,
        etiquetaDetalhe: false,
        reverter: false,
        transformar: false,
        rejeitar: false

      },
      {
        IdStatus: '4', //Cancelado
        Perfil: 'Filial',
        clienteInfo: false,
        novaOF: false,
        gerarOF: false,
        encerrarOF: false,
        cancelarOF: false,
        imprimir: false,
        gerarExcel: false,
        etiquetaPeloLote: false,
        etiquetaDetalhe: false,
        reverter: false,
        transformar: false,
        rejeitar: false

      },
      {
        IdStatus: '6', //Transformado
        Perfil: 'Filial',
        clienteInfo: false,
        novaOF: false,
        gerarOF: false,
        encerrarOF: false,
        cancelarOF: false,
        imprimir: false,
        gerarExcel: false,
        etiquetaPeloLote: false,
        etiquetaDetalhe: false,
        reverter: false,
        transformar: false,
        rejeitar: false

      },
      {
        IdStatus: '7', //Rejeitado
        Perfil: 'Filial',
        clienteInfo: false,
        novaOF: false,
        gerarOF: false,
        encerrarOF: false,
        cancelarOF: false,
        imprimir: false,
        gerarExcel: false,
        etiquetaPeloLote: false,
        etiquetaDetalhe: false,
        reverter: false,
        transformar: false,
        rejeitar: false

      }
    ],
    contrato: [
      {
        IdStatus: '1',
        Perfil: 'TI',
        status: false,
        salvar: false,
        ativar: false,
        excluir: false,
        numeroContrato: false,
        empresa: false,
        tipoUtilizacao: false,
        moeda: false,
        dataInicio: false,
        dataVencimento: false,
        vencimento: false,
        dataReajuste: false,
        tipoFrete: false,
        transporte: false,
        transportadora: false,
        transportadoraRedespacho: false,
        sap: false,
        redespacho: false,
        observacoes: false,
        itens: false,
        clientes: false,
        followUp: false,
        salvarContrato: false,
        criarContrato: true
      },
      {
        IdStatus: '1',
        Perfil: 'Financeiro',
        clienteInfo: false,
        status: true,
        salvar: true,
        ativar: true,
        excluir: true,
        numeroContrato: true,
        empresa: true,
        tipoUtilizacao: true,
        moeda: true,
        dataInicio: true,
        dataVencimento: true,
        vencimento: false,
        dataReajuste: true,
        tipoFrete: true,
        transporte: true,
        transportadora: true,
        transportadoraRedespacho: true,
        sap: true,
        redespacho: true,
        observacoes: true,
        itens: true,
        clientes: true,
        followUp: true,
        salvarContrato: false,
        criarContrato: true
      },
      {
        IdStatus: '1',
        Perfil: 'VendasExterna',
        clienteInfo: false,
        status: false,
        salvar: false,
        ativar: false,
        excluir: false,
        numeroContrato: false,
        empresa: false,
        tipoUtilizacao: false,
        moeda: false,
        dataInicio: false,
        dataVencimento: false,
        vencimento: true,
        dataReajuste: false,
        tipoFrete: false,
        transporte: false,
        transportadora: false,
        transportadoraRedespacho: false,
        sap: false,
        redespacho: false,
        observacoes: false,
        itens: false,
        clientes: false,
        followUp: false,
        salvarContrato: false,
        criarContrato: false
      },
      {
        IdStatus: '1',
        Perfil: 'VendasInternas',
        status: false,
        clienteInfo: false,
        salvar: false,
        ativar: false,
        excluir: false,
        numeroContrato: false,
        empresa: false,
        tipoUtilizacao: false,
        moeda: false,
        dataInicio: false,
        dataVencimento: false,
        vencimento: true,
        dataReajuste: false,
        tipoFrete: false,
        transporte: false,
        transportadora: false,
        transportadoraRedespacho: false,
        sap: false,
        redespacho: false,
        observacoes: false,
        itens: false,
        clientes: false,
        followUp: false,
        salvarContrato: false,
        criarContrato: false
      },
      {
        IdStatus: '1',
        Perfil: 'Diretor',
        status: true,
        salvar: true,
        ativar: true,
        excluir: true,
        numeroContrato: true,
        empresa: true,
        tipoUtilizacao: true,
        moeda: true,
        dataInicio: true,
        dataVencimento: true,
        vencimento: true,
        dataReajuste: true,
        tipoFrete: true,
        transporte: true,
        transportadora: true,
        transportadoraRedespacho: true,
        sap: true,
        redespacho: true,
        observacoes: true,
        itens: true,
        clientes: true,
        followUp: true,
        salvarContrato: true,
        criarContrato: true
      },
      {
        IdStatus: '1',
        Perfil: 'Fabrica',
        clienteInfo: true,
        status: true,
        salvar: true,
        ativar: true,
        excluir: true,
        numeroContrato: true,
        empresa: true,
        tipoUtilizacao: true,
        moeda: true,
        dataInicio: true,
        dataVencimento: true,
        vencimento: true,
        dataReajuste: true,
        tipoFrete: true,
        transporte: true,
        transportadora: true,
        transportadoraRedespacho: true,
        sap: true,
        redespacho: true,
        observacoes: true,
        itens: true,
        clientes: true,
        followUp: true,
        salvarContrato: true,
        criarContrato: true
      },
      {
        IdStatus: '1',
        Perfil: 'Faturista',
        clienteInfo: false,
        status: true,
        salvar: true,
        ativar: true,
        excluir: true,
        numeroContrato: true,
        empresa: true,
        tipoUtilizacao: true,
        moeda: true,
        dataInicio: true,
        dataVencimento: true,
        vencimento: true,
        dataReajuste: true,
        tipoFrete: true,
        transporte: true,
        transportadora: true,
        transportadoraRedespacho: true,
        sap: true,
        redespacho: true,
        observacoes: true,
        itens: true,
        clientes: true,
        followUp: true,
        salvarContrato: true,
        criarContrato: true
      },
      {
        IdStatus: '1',
        Perfil: 'Filial',
        clienteInfo: false,
        status: true,
        salvar: true,
        ativar: true,
        excluir: true,
        numeroContrato: true,
        empresa: true,
        tipoUtilizacao: true,
        moeda: true,
        dataInicio: true,
        dataVencimento: true,
        vencimento: true,
        dataReajuste: true,
        tipoFrete: true,
        transporte: true,
        transportadora: true,
        transportadoraRedespacho: true,
        sap: true,
        redespacho: true,
        observacoes: true,
        itens: true,
        clientes: true,
        followUp: true,
        salvarContrato: true,
        criarContrato: true
      },
      {
        IdStatus: '1',
        Perfil: 'Fiscal',
        clienteInfo: false,
        status: true,
        salvar: true,
        ativar: true,
        excluir: true,
        numeroContrato: true,
        empresa: true,
        tipoUtilizacao: true,
        moeda: true,
        dataInicio: true,
        dataVencimento: true,
        vencimento: true,
        dataReajuste: true,
        tipoFrete: true,
        transporte: true,
        transportadora: true,
        transportadoraRedespacho: true,
        sap: true,
        redespacho: true,
        observacoes: true,
        itens: true,
        clientes: true,
        followUp: true,
        salvarContrato: true,
        criarContrato: true
      },
      {
        IdStatus: '1',
        Perfil: 'PCP',
        clienteInfo: true,
        status: true,
        salvar: true,
        ativar: true,
        excluir: true,
        numeroContrato: true,
        empresa: true,
        tipoUtilizacao: true,
        moeda: true,
        dataInicio: true,
        dataVencimento: true,
        vencimento: true,
        dataReajuste: true,
        tipoFrete: true,
        transporte: true,
        transportadora: true,
        transportadoraRedespacho: true,
        sap: true,
        redespacho: true,
        observacoes: true,
        itens: true,
        clientes: true,
        followUp: true,
        salvarContrato: true,
        criarContrato: true
      },
      {
        IdStatus: '1',
        Perfil: 'Qualidade', clienteInfo: false,
        status: true,
        salvar: true,
        ativar: true,
        excluir: true,
        numeroContrato: true,
        empresa: true,
        tipoUtilizacao: true,
        moeda: true,
        dataInicio: true,
        dataVencimento: true,
        vencimento: true,
        dataReajuste: true,
        tipoFrete: true,
        transporte: true,
        transportadora: true,
        transportadoraRedespacho: true,
        sap: true,
        redespacho: true,
        observacoes: true,
        itens: true,
        clientes: true,
        followUp: true,
        salvarContrato: true,
        criarContrato: true
      },
      {
        IdStatus: '1',
        Perfil: 'Recebimento',
        clienteInfo: false,
        status: true,
        salvar: true,
        ativar: true,
        excluir: true,
        numeroContrato: true,
        empresa: true,
        tipoUtilizacao: true,
        moeda: true,
        dataInicio: true,
        dataVencimento: true,
        vencimento: true,
        dataReajuste: true,
        tipoFrete: true,
        transporte: true,
        transportadora: true,
        transportadoraRedespacho: true,
        sap: true,
        redespacho: true,
        observacoes: true,
        itens: true,
        clientes: true,
        followUp: true,
        salvarContrato: true,
        criarContrato: true
      }
    ],
    oportunidade: [
      {
        IdStatus: '999', //sem acesso
        Perfil: '',
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        integracao: true,
        updateItem: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '0', //Rascunho
        Perfil: 'TI',
        cliente: false,
        clienteInfo: false,
        RazaoSocial: false,
        empresa: false,
        tipoDeRemessa: false,
        dataDoRecebimento: false,
        tipoDeUtilizacao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        updateItem: false,
        integracao: false,
        observacaoPedido: false,
        observacaoNota: false,
        aprovar: false,
        salvar: false,
        editar: false,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: false,
      },
      {
        IdStatus: '1', //aprovado
        Perfil: 'TI',
        cliente: false,
        clienteInfo: false,
        RazaoSocial: false,
        empresa: false,
        tipoDeRemessa: false,
        dataDoRecebimento: false,
        tipoDeUtilizacao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        updateItem: false,
        integracao: false,
        observacaoPedido: false,
        observacaoNota: false,
        aprovar: false,
        salvar: false,
        editar: false,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: false,
      },
      {
        IdStatus: '0', //Rascunho
        Perfil: 'Engenharia',
        cliente: true,
        clienteInfo: true,
        RazaoSocial: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        integracao: true,
        updateItem: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '1', //Aprovado
        Perfil: 'Engenharia',
        cliente: true,
        clienteInfo: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        integracao: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarIsencoes: true,
        editarValorTotalDoubleCheck: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '2', //Bloqueado
        Perfil: 'Engenharia',
        cliente: true,
        clienteInfo: true,
        RazaoSocial: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        integracao: true,
        updateItem: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '3', //Excluído
        Perfil: 'Engenharia',
        cliente: true,
        clienteInfo: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        integracao: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '4', //Rascunho
        Perfil: 'Engenharia',
        cliente: true,
        clienteInfo: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        integracao: true,
        updateItem: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '5', //Devolvido
        Perfil: 'Engenharia',
        cliente: true,
        clienteInfo: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        integracao: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '6', //Cancelado
        Perfil: 'Engenharia',
        cliente: true,
        clienteInfo: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        integracao: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '7', //Aprovado Parcialmente
        Perfil: 'Engenharia',
        cliente: true,
        clienteInfo: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        integracao: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '0', //Rascunho
        Perfil: 'VendasInternas',
        cliente: false,
        clienteInfo: false,
        RazaoSocial: false,
        empresa: false,
        tipoDeRemessa: false,
        dataDoRecebimento: false,
        tipoDeUtilizacao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        integracao: true,
        updateItem: false,
        observacaoPedido: false,
        observacaoNota: false,
        aprovar: false,
        salvar: false,
        editar: false,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: true
      },
      {
        IdStatus: '1', //Aprovado
        Perfil: 'VendasInternas',
        cliente: true,
        clienteInfo: false,
        empresa: true,
        tipoDeRemessa: false,
        dataDoRecebimento: true,
        tipoDeUtilizacao: false,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        updateItem: true,
        integracao: true,
        observacaoPedido: false,
        observacaoNota: false,
        aprovar: true,
        salvar: false,
        editar: false,
        editarIsencoes: false,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '2', //Bloqueado
        Perfil: 'VendasInternas',
        cliente: false,
        clienteInfo: false,
        RazaoSocial: false,
        empresa: false,
        tipoDeRemessa: false,
        dataDoRecebimento: false,
        tipoDeUtilizacao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        integracao: true,
        updateItem: false,
        observacaoPedido: false,
        observacaoNota: false,
        aprovar: true,
        salvar: false,
        editar: false,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: true
      },
      {
        IdStatus: '3', //Excluído
        Perfil: 'VendasInternas',
        cliente: true,
        clienteInfo: false,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        integracao: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '4', //Rascunho
        Perfil: 'VendasInternas',
        cliente: false,
        clienteInfo: false,
        empresa: false,
        tipoDeRemessa: false,
        dataDoRecebimento: false,
        tipoDeUtilizacao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        integracao: true,
        updateItem: false,
        observacaoPedido: false,
        observacaoNota: false,
        aprovar: false,
        salvar: false,
        editar: false,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '5', //Devolvido
        Perfil: 'VendasInternas',
        cliente: true,
        clienteInfo: false,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        integracao: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '6', //Cancelado
        Perfil: 'VendasInternas',
        cliente: true,
        clienteInfo: false,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        integracao: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '7', //Aprovado Parcialmente
        Perfil: 'VendasInternas',
        cliente: true,
        clienteInfo: false,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: false,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: false,
        updateItem: true,
        integracao: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: false,
        salvar: false,
        editar: true,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '0', //Rascunho
        Perfil: 'Fiscal',
        clienteInfo: false,
        cliente: false,
        RazaoSocial: false,
        empresa: false,
        tipoDeRemessa: false,
        dataDoRecebimento: false,
        tipoDeUtilizacao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        integracao: true,
        addItem: false,
        observacaoPedido: false,
        observacaoNota: false,
        aprovar: false,
        salvar: false,
        editar: false,
        criar: false,
        detalheDoItem: false,
        duplicar: true
      },
      {
        IdStatus: '1', //Aprovado
        Perfil: 'Fiscal',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        integracao: true,
        addItem: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: false,
        editar: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '2', //Bloqueado
        Perfil: 'Fiscal',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        integracao: true,
        addItem: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '3', //Excluído
        Perfil: 'Fiscal',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        integracao: true,
        addItem: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '4', //Rascunho
        Perfil: 'Fiscal',
        clienteInfo: false,
        cliente: false,
        empresa: false,
        tipoDeRemessa: false,
        dataDoRecebimento: false,
        tipoDeUtilizacao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        integracao: true,
        addItem: false,
        observacaoPedido: false,
        observacaoNota: false,
        aprovar: false,
        salvar: false,
        editar: false,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '5', //Devolvido
        Perfil: 'Fiscal',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        integracao: true,
        addItem: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '6', //Cancelado
        Perfil: 'Fiscal',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        integracao: true,
        addItem: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '0', //Rascunho
        Perfil: 'Financeiro',
        clienteInfo: false,
        cliente: false,
        RazaoSocial: false,
        empresa: false,
        tipoDeRemessa: false,
        dataDoRecebimento: false,
        tipoDeUtilizacao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        integracao: true,
        addItem: false,
        observacaoPedido: false,
        observacaoNota: false,
        aprovar: true,
        salvar: false,
        editar: false,
        criar: false,
        detalheDoItem: false,
        duplicar: true
      },
      {
        IdStatus: '1', //Aprovado
        Perfil: 'Financeiro',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        integracao: true,
        addItem: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: false,
        editar: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '2', //Bloqueado
        Perfil: 'Financeiro',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        integracao: true,
        addItem: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: false,
        editar: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '3', //Excluído
        Perfil: 'Financeiro',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        integracao: true,
        addItem: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '4', //Rascunho
        Perfil: 'Financeiro',
        clienteInfo: false,
        cliente: false,
        empresa: false,
        tipoDeRemessa: false,
        dataDoRecebimento: false,
        tipoDeUtilizacao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        integracao: true,
        addItem: false,
        observacaoPedido: false,
        observacaoNota: false,
        aprovar: true,
        salvar: false,
        editar: false,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '5', //Devolvido
        Perfil: 'Financeiro',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        integracao: true,
        addItem: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '6', //Cancelado
        Perfil: 'Financeiro',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        integracao: true,
        addItem: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '7', //Aprovado Parcialmente
        Perfil: 'Financeiro',
        clienteInfo: false,
        cliente: false,
        RazaoSocial: false,
        empresa: false,
        tipoDeRemessa: false,
        dataDoRecebimento: false,
        tipoDeUtilizacao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        integracao: true,
        addItem: false,
        observacaoPedido: false,
        observacaoNota: false,
        aprovar: true,
        salvar: false,
        editar: false,
        criar: false,
        detalheDoItem: false,
        duplicar: true
      },
      {
        IdStatus: '0', //Rascunho
        Perfil: 'PCP',
        clienteInfo: true,
        cliente: false,
        RazaoSocial: false,
        empresa: false,
        tipoDeRemessa: false,
        dataDoRecebimento: false,
        tipoDeUtilizacao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        integracao: true,
        updateItem: false,
        observacaoPedido: false,
        observacaoNota: false,
        aprovar: false,
        salvar: false,
        editar: false,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: true
      },
      {
        IdStatus: '1', //Aprovado
        Perfil: 'PCP',
        clienteInfo: true,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: false,
        moeda: true,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        updateItem: true,
        integracao: true,
        observacaoPedido: false,
        observacaoNota: false,
        aprovar: true,
        salvar: false,
        editar: false,
        editarIsencoes: true,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '2', //Bloqueado
        Perfil: 'PCP',
        clienteInfo: true,
        cliente: false,
        RazaoSocial: false,
        empresa: false,
        tipoDeRemessa: false,
        dataDoRecebimento: false,
        tipoDeUtilizacao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        integracao: true,
        updateItem: false,
        observacaoPedido: false,
        observacaoNota: false,
        aprovar: true,
        salvar: false,
        editar: false,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: true
      },
      {
        IdStatus: '3', //Excluído
        Perfil: 'PCP',
        clienteInfo: true,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        integracao: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '4', //Rascunho
        Perfil: 'PCP',
        clienteInfo: true,
        cliente: false,
        empresa: false,
        tipoDeRemessa: false,
        dataDoRecebimento: false,
        tipoDeUtilizacao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        integracao: true,
        updateItem: false,
        observacaoPedido: false,
        observacaoNota: false,
        aprovar: false,
        salvar: false,
        editar: false,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '5', //Devolvido
        Perfil: 'PCP',
        clienteInfo: true,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        integracao: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '6', //Cancelado
        Perfil: 'PCP',
        clienteInfo: true,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        integracao: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '7', //Aprovado Parcialmente
        Perfil: 'PCP',
        clienteInfo: true,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: false,
        updateItem: true,
        integracao: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: false,
        salvar: false,
        editar: true,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '0', //Rascunho
        Perfil: 'Faturista',
        clienteInfo: false,
        cliente: false,
        RazaoSocial: false,
        empresa: false,
        tipoDeRemessa: false,
        dataDoRecebimento: false,
        tipoDeUtilizacao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        integracao: true,
        updateItem: false,
        observacaoPedido: false,
        observacaoNota: false,
        aprovar: false,
        salvar: false,
        editar: false,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: true
      },
      {
        IdStatus: '1', //Aprovado
        Perfil: 'Faturista',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: false,
        moeda: true,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        updateItem: true,
        integracao: true,
        observacaoPedido: false,
        observacaoNota: false,
        aprovar: true,
        salvar: false,
        editar: false,
        editarIsencoes: true,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '2', //Bloqueado
        Perfil: 'Faturista',
        clienteInfo: false,
        cliente: false,
        RazaoSocial: false,
        empresa: false,
        tipoDeRemessa: false,
        dataDoRecebimento: false,
        tipoDeUtilizacao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        integracao: true,
        updateItem: false,
        observacaoPedido: false,
        observacaoNota: false,
        aprovar: true,
        salvar: false,
        editar: false,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: true
      },
      {
        IdStatus: '3', //Excluído
        Perfil: 'Faturista',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        integracao: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '4', //Rascunho
        Perfil: 'Faturista',
        clienteInfo: false,
        cliente: false,
        empresa: false,
        tipoDeRemessa: false,
        dataDoRecebimento: false,
        tipoDeUtilizacao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        integracao: true,
        updateItem: false,
        observacaoPedido: false,
        observacaoNota: false,
        aprovar: false,
        salvar: false,
        editar: false,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '5', //Devolvido
        Perfil: 'Faturista',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        integracao: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '6', //Cancelado
        Perfil: 'Faturista',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        integracao: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '7', //Aprovado Parcialmente
        Perfil: 'Faturista',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: false,
        updateItem: true,
        integracao: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: false,
        salvar: false,
        editar: true,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '0', //Rascunho
        Perfil: 'Qualidade',
        clienteInfo: false,
        cliente: true,
        RazaoSocial: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        integracao: true,
        updateItem: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '1', //Aprovado
        Perfil: 'Qualidade',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        integracao: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarIsencoes: true,
        editarValorTotalDoubleCheck: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '2', //Bloqueado
        Perfil: 'Qualidade',
        clienteInfo: false,
        cliente: true,
        RazaoSocial: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        integracao: true,
        updateItem: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '3', //Excluído
        Perfil: 'Qualidade',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        integracao: true,
        updateItem: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '4', //Rascunho
        Perfil: 'Qualidade',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        integracao: true,
        updateItem: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '5', //Devolvido
        Perfil: 'Qualidade',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        integracao: true,
        updateItem: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '6', //Cancelado
        Perfil: 'Qualidade',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        integracao: true,
        updateItem: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '7', //Aprovado Parcialmente
        Perfil: 'Qualidade',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        integracao: true,
        updateItem: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: true,
        detalheDoItem: true,
        duplicar: true
      },
      {
        IdStatus: '0', //Rascunho
        Perfil: 'Filial',
        clienteInfo: false,
        cliente: false,
        RazaoSocial: false,
        empresa: false,
        tipoDeRemessa: false,
        dataDoRecebimento: false,
        tipoDeUtilizacao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        integracao: true,
        updateItem: false,
        observacaoPedido: false,
        observacaoNota: false,
        aprovar: false,
        salvar: false,
        editar: false,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: true
      },
      {
        IdStatus: '1', //Aprovado
        Perfil: 'Filial',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: false,
        dataDoRecebimento: true,
        tipoDeUtilizacao: false,
        contato: true,
        removeContato: false,
        moeda: true,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        updateItem: true,
        integracao: true,
        observacaoPedido: false,
        observacaoNota: false,
        aprovar: true,
        salvar: false,
        editar: false,
        editarIsencoes: false,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '2', //Bloqueado
        Perfil: 'Filial',
        clienteInfo: false,
        cliente: false,
        RazaoSocial: false,
        empresa: false,
        tipoDeRemessa: false,
        dataDoRecebimento: false,
        tipoDeUtilizacao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        integracao: true,
        updateItem: false,
        observacaoPedido: false,
        observacaoNota: false,
        aprovar: true,
        salvar: false,
        editar: false,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: true
      },
      {
        IdStatus: '3', //Excluído
        Perfil: 'Filial',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        integracao: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '4', //Rascunho
        Perfil: 'Filial',
        clienteInfo: false,
        cliente: false,
        empresa: false,
        tipoDeRemessa: false,
        dataDoRecebimento: false,
        tipoDeUtilizacao: false,
        contato: false,
        removeContato: false,
        moeda: false,
        tipoDeFrete: false,
        tipoDeTransporte: false,
        addItem: false,
        integracao: true,
        updateItem: false,
        observacaoPedido: false,
        observacaoNota: false,
        aprovar: false,
        salvar: false,
        editar: false,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '5', //Devolvido
        Perfil: 'Filial',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        integracao: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '6', //Cancelado
        Perfil: 'Filial',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: true,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: true,
        updateItem: true,
        integracao: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: true,
        salvar: true,
        editar: true,
        editarValorTotalDoubleCheck: true,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
      {
        IdStatus: '7', //Aprovado Parcialmente
        Perfil: 'Filial',
        clienteInfo: false,
        cliente: true,
        empresa: true,
        tipoDeRemessa: true,
        dataDoRecebimento: true,
        tipoDeUtilizacao: true,
        contato: false,
        removeContato: true,
        moeda: true,
        tipoDeFrete: true,
        tipoDeTransporte: true,
        addItem: false,
        updateItem: true,
        integracao: true,
        observacaoPedido: true,
        observacaoNota: true,
        aprovar: false,
        salvar: false,
        editar: true,
        editarValorTotalDoubleCheck: false,
        criar: false,
        detalheDoItem: false,
        duplicar: false
      },
    ]
  },
  Documentos: [
    {
      Id: 1,
      Nome: 'Documentação EDI',
      Link: 'https://teaditbr.sharepoint.com/:u:/s/ITWiki/IQCNOw_IeFjzT5jLTlbnebOsAQusnoQCgG6m73wCDz2bwz8?e=HooBrC',
    },
    {
      Id: 2,
      Nome: 'Documentação Datas de Entrega',
      Link: 'https://teaditbr.sharepoint.com/:u:/r/sites/ITWiki/SitePages/Defini%C3%A7%C3%A3o-de-datas-de-entrega---Midas.aspx?csf=1&web=1&share=IQAEcAFGOxiATZgcr-NBMucaAcXQKgLIMwSkPYyUZwfE1KM&e=R6pRd1',
    },
    {
      Id: 3,
      Nome: 'Documentação Embalagens de Transporte',
      Link: '',
    },
    {
      Id: 4,
      Nome: 'Documentação Embalagens de Produto',
      Link: '',
    }
  ],
  devExpressKey:'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjdjMzlmMGMxLThmMGYtMTFlNi04MGQ0LTAwMTU1ZDYyNDgwYiIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUyCn0=.HgwkeMCRR+0nJImbvoDvjFtXGaGH8Htb8pjltt0d84scGyl1a0B8nfplEWphAHTXLQdN5rL9LiddA3zjwntGe6d+4ofBeejKMTqPxBe/QRjc+GTDKMmwIZHPj712x6+frwfW+A=='
};


